<template>
  <div class="charts-container">
    <div class="Hcp-operate" id="operate-button"  :class="{'zh1':!isEn,'de1':isDe,'du1':isDu||isSw}">
      <button class="operate-spe3" :class="{'operate-spe1':A0}" @click="select(0)">
        <span>{{$t('dashboard')}}</span>
      </button>
      <button :class="{'operate-spe1':A}" @click="select(1)">
        <span>{{$t('daily')}}</span>
      </button>
      <button :class="{'operate-spe1':B}" @click="select(2)">
        <span>{{$t('dayByday')}}</span>
      </button>
      <button :class="{'operate-spe1':C}" @click="select(3)">
        <span>{{$t('sensorOverlay')}}</span>
      </button>
      <button :class="{'operate-spe1':D}" @click="select(4)">
        <span>{{$t('TrendAna')}}</span>
      </button>
      <!--<button :class="{'operate-spe1':G}" @click="select(7)" v-show="segment">
        <span>{{$t('Segment Analysis')}}</span>
      </button>-->
      <button :class="{'operate-spe1':H}" @click="select(8)" v-show="segment">
        <span>{{$t('events')}}</span>
      </button>
      <button :class="{'operate-spe1':E}" @click="select(5)" v-show="notM">
        <span>{{$t('logbook')}}</span>
      </button>
      <button :class="{'operate-spe1':J}" @click="select(9)" v-show="notM">
        <span>{{$t('alert')}}</span>
      </button>
      <button class="operate-spe2" :class="{'operate-spe1':F}" @click="select(6)" v-show="notM">
        <span>{{$t('DeviceSetting')}}</span>
      </button>
    </div>
    
    <el-card id="Hcp-main">
      <div class="Hcp-main-context">
          <el-col :span="24">
            <!-- <keep-alive> -->
              <router-view :key="chart" v-on:reload="reload"></router-view>
            <!-- </keep-alive> -->
          </el-col>
      </div>
    </el-card>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        A0:'', A:'', B:'',C:'',D:'',E:'',F:'', items:[true,false,false,false,false,false],isSw:false,
        value1: '',value2: '',value3: '',notM:true,isEn:false,G:'',H:'',J:'', segment:true,isDe:false,isDu:false,
        chart: '',

        navbar:[{
          'name':'dashboard',
          'index': 0
        },{
          'name':'dashboard',
          'index': 0
        },{
          'name':'dashboard',
          'index': 0
        },]
      }
    },
    mounted(){
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isSw = (lang==='sw')?true:false;
        /*若将这六个参数写在数组中，则出错，刷新又依照默认值渲染，？？？*/
      this.A0 = (this.$route.path ==='/chart0')?true:false;
      this.A = (this.$route.path ==='/chart1')?true:false;
      this.B = (this.$route.path ==='/chart2')?true:false;
      this.C = (this.$route.path ==='/chart3')?true:false;
      this.D = (this.$route.path ==='/chart4')?true:false;
      this.E = (this.$route.path ==='/chart5')?true:false;
      this.F = (this.$route.path ==='/chart6')?true:false;
      this.G = (this.$route.path ==='/chart7')?true:false;
      this.H = (this.$route.path ==='/chart8')?true:false;
      this.J = (this.$route.path ==='/chart9')?true:false;
      this.notM = (sessionStorage.getItem('userType')==='M')?false:true;

      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      

    },

    methods:{
      select(index){
        let path = '/chart'+index;
        this.A0 = (path ==='/chart0')?true:false;
        this.A = (path ==='/chart1')?true:false;
        this.B = (path ==='/chart2')?true:false;
        this.C = (path ==='/chart3')?true:false;
        this.D = (path ==='/chart4')?true:false;
        this.E = (path ==='/chart5')?true:false;
        this.F = (path ==='/chart6')?true:false;
        this.G = (path ==='/chart7')?true:false;
        this.H = (path ==='/chart8')?true:false;
        this.J = (path ==='/chart9')?true:false;
        this.$router.push(path);

        /*console.log('charts:'+this.uid)
        let that=this;
        auth.getDataMap(this, this.uid, function(res){
          if (0!=res.error) {
            return;
          }
          var chart_end_time=(res.end.cgms > res.end.pump)?res.end.cgms:res.end.pump;
          sessionStorage.setItem('chart_end_time', chart_end_time)
          that.$router.push(path);
        })*/
      },
      back(){
        this.$router.push('/PatientList');
      },
      reload () {
      this.chart = new Date().getTime()
    }
    },
  }
</script>

<style scoped>
  .charts-container{
    height:100%;
    width:100%;
    margin:0 auto;
    background:#fafbfc;
  }
  .Hcp-operate{
    width:94%;
    margin: 0 auto;
  }
  .Hcp-operate button{
    border: 1px solid #a3a3a3;
    outline: none;
    border-radius:100px;
    font-family:SFUIText-Regular;
    box-shadow:0 3px 4px 0 #e8f3ff;
    font-size:15px;
    color:#282828;
    height:30px;
    line-height: 30px;
    min-width: 100px;
    letter-spacing:-0.39px;
    text-align:center;
    margin-right:1.2%;
    margin-top: 20px;
    background:#ffffff;
    cursor: pointer;
  }
  .Hcp-operate .operate-spe1{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#ffffff;
    border: none;
  }
  .Hcp-operate .operate-spe2{
    margin-right: 0;
  }
  .zh1 button{
    margin-right:2%;
  }
  .zh1 .operate-spe3{
    margin-left: 4%;
  }
  .Hcp-operate span{
    margin:0 18px;
  }
  #Hcp-main{
    margin:15px auto 0;
    width: 97%;
    background:#fff;
    box-shadow:0 3px 4px 0 rgba(175,175,175,0.50);
    border-radius:6px;
    border:none;
  }
  .chart{
    width:100%;
  }
  .de1 button{
    margin-right:1%;
  }
  .de1 span{
    margin:0 10px;
  }
  .du1 button{
    margin-right:1%;
  }
  .du1 span{
    margin:0 15px;
  }
  @media screen and (max-width: 1300px){
    .Hcp-operate button{
      margin-right: 1%;
      min-width: 80px;
    }
    .zh1 button{
      margin-right:3%;
    }
    .zh1 .operate-spe3{
      margin-left: 6%;
    }
    .Hcp-operate span{
      margin:0 10px;
    }
    .de1 span{
      margin:0 5px;
    }
    .du1 button{
      margin-right:1%;
    }
    .du1 span{
      margin:0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// charts.vue?3e1742fa